// extracted by mini-css-extract-plugin
export default {"ColorDecoratorMain":"ColorDecorator-module__ColorDecoratorMain__KzjEbqH"};